import { module } from 'modujs';
import { html } from '../utils/environment'
import { getFirstFocusableElement } from '../utils/getFirstFocusableElement'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.closeBind = (e) => {
             if (e.key === "Escape") {
                this.close();
            }
        }

        document.addEventListener('keyup', this.closeBind)

        this.$navItems = this.el.querySelectorAll('.js-nav-item')

        this.$navItems.length && gsap.set(this.$navItems, {y: "100%", autoAlpha: 0})
    }

    /**
     * toggle
     *
     * @param
     */
    toggle() {
        if(html.classList.contains('has-menu-open')) {
            this.close()
        } else {
            this.open()
        }
    }

    /**
     * open
     *
     * @param
     */
    open() {
        html.classList.add('has-menu-open')

        setTimeout(() => {
            getFirstFocusableElement(this.el)
        }, 1200);

        this.$navItems.length && gsap.to(this.$navItems, {
            y: 0,
            autoAlpha: 1,
            duration: .4,
            stagger: { // wrap advanced options in an object
                each: 0.03,
                ease: "Power1.easeOut"
            }
        });
    }

    /**
     * close
     *
     * @param
     */
    close() {
        html.classList.remove('has-menu-open')

        const $main = document.querySelector('main')
        getFirstFocusableElement($main)

        if (this.$navItems.length) {
            const items = [ ...this.$navItems ]
            const reversedItems = items.reverse();
            gsap.to(reversedItems, {
                y: "100%",
                autoAlpha: 0,
                duration: .3,
                stagger: { // wrap advanced options in an object
                    each: 0.01,
                    ease: "Power2.easeOut"
                }
            });
        }
    }

    destroy() {
        super.destroy()
        document.removeEventListener('keyup', this.closeBind)
    }
}
